import React, { useState, useEffect } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import classes from "./InvoiceObject.module.scss";
import SelectPartial from "../components/selectPartial/SelectPartial";
import DetailsTable from "../components/InvoiceObjectComponents/DetailsTable";
import { Container } from "react-bootstrap";
import useWindowSize from "../hooks/useWindowSize";
import MobileVersion from "../components/mobileVersion/MobileVersion";
import LoadingDots from "../components/UI/LoadingDots";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const InvoiceObject = () => {
  const [chosenPartial, setChosenPartial] = useState("Normal");
  const [dataToDisplay, setDataToDisplay] = useState(null);
  const [propKeys, setPropKeys] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { width } = useWindowSize();

  const onChoosePartialHandler = (partial) => {
    setChosenPartial(partial);
    setIsLoading(true);
  };

  useEffect(() => {
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.DDDI_GetNew",
            args: {
              Complexity: chosenPartial,
              IncludeInfo: true,
            },
          },
          id: 1,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.result && res.data.result.Result) {
          if (res.data.result.Result.JSONSchema) {
            const data = res.data.result.Result.JSONSchema.properties.Invoice;
            setDataToDisplay(data);
            setPropKeys(Object.keys(data.properties));
            setIsLoading(false);
          }
        }
      });
  }, [chosenPartial]);

  return (
    <>
      <Helmet>
        <title>Invoice Object | DDD Invoices</title>
      </Helmet>

      {width > 768 && (
        <Container className={`w-100 h-100 p-5 ${classes.container}`}>
          <SelectPartial
            onChoosePartialHandler={onChoosePartialHandler}
            value={chosenPartial}
          />

          {!isLoading && dataToDisplay && (
            <div className={`mt-5 ${classes["table-container"]}`}>
              <table className="w-100">
                <thead>
                  <tr className={classes["first-row"]}>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Required</th>
                  </tr>
                </thead>
                <tbody>
                  {propKeys.map((property, index) => {
                    if (property === "_details") {
                      let details =
                        dataToDisplay.properties[property].properties;
                      return (
                        <>
                          <tr key={`invoice-obj-prop-${index}`}>
                            <td>{property}</td>
                            <td>
                              {Array.isArray(
                                dataToDisplay.properties[property].type
                              )
                                ? dataToDisplay.properties[property].type.join(
                                    " | "
                                  )
                                : dataToDisplay.properties[property].type}
                            </td>
                            <td>
                              {dataToDisplay.properties[property].description}
                            </td>
                            <td>
                              {dataToDisplay.required.includes(property)
                                ? "true"
                                : "false"}
                            </td>
                          </tr>
                          {Object.keys(details).map((detail, index) => {
                            return (
                              <>
                                <tr
                                  key={`invoice-obj-detail-${index}`}
                                  className={classes.expand}
                                >
                                  <td colSpan="4">{detail}</td>
                                </tr>
                                <tr>
                                  <td colSpan={4}>
                                    <DetailsTable
                                      required={details[detail].items.required}
                                      propsData={
                                        details[detail].items.properties
                                      }
                                      arrayOfProps={Object.keys(
                                        details[detail].items.properties
                                      )}
                                    />
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </>
                      );
                    }
                    return (
                      <tr key={`invoice-obj-prop-${index}`}>
                        <td>{property}</td>
                        <td>
                          {dataToDisplay.properties[property].$d3pro
                            ? dataToDisplay.properties[property].$d3pro
                                .JSONBasicType
                            : Array.isArray(
                                dataToDisplay.properties[property].type
                              )
                            ? dataToDisplay.properties[property].type.join(
                                " | "
                              )
                            : dataToDisplay.properties[property].type}
                        </td>
                        <td>
                          {dataToDisplay.properties[property].description}
                        </td>
                        <td>
                          {dataToDisplay.required.includes(property)
                            ? "true"
                            : "false"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {isLoading && (
            <LoadingDots className="w-100 h-100 d-flex align-items-center justify-content-center" />
          )}
        </Container>
      )}
      {width <= 768 && <MobileVersion />}
    </>
  );
};

export default InvoiceObject;
